import React 				from 'react';
import ReactDOM 			from 'react-dom';

import BLComponent			from '../core/_BLComponent'
import {ClickShowTooltip, CustomAlert, onEscapePress} 	from '../common/_Utilities.jsx';
import Preloader 			from '../common/_Preloader.jsx';
import HiddenScroll 		from '../common/_HiddenScroll.jsx';
import InfoDrawer 			from '../common/_InfoDrawer.jsx';
import SimpleProductCard 	from '../common/_SimpleProductCard.jsx';
import CustomCheckbox 		from '../common/_CustomCheckbox.jsx';
import DropdownInput 		from '../common/_DropdownInput.jsx';
import LimitedTextField 	from '../common/_LimitedTextField.jsx';
import SellerStoreLockup 	from '../common/_SellerStoreLockup.jsx';
import GermanWarning 	from '../common/_GermanWarning.jsx';

import ModalStoreRow 		from './_ModalStoreRow.jsx';

export default class EasyBuyModal extends BLComponent
{
	constructor( props ) 
	{
		super( props );

		let wlFetch, origin, originName, itemsToBuy;

		if ( props.hasOwnProperty( "fromWantedList" ) && props.fromWantedList >= 0 )
		{
			wlFetch		= props.fromWantedList;
			origin		= "wantedList";
			originName	= "";
			itemsToBuy	= [];
		}
		else
		{
			wlFetch		= -1;
			origin		= props.origin;
			originName	= props.originName ? props.originName : "";
			itemsToBuy	= props.itemsToBuy;
		}

		this.state = 
			{
				stage: 				1			// 1: Loading Stage, 2: Initial Scan, 3: Full Scan, 4: Result, 5: Success, 6: Error
			,	inTransition: 		false
			,	newWantedlist: 		''
			,	selectedWantedList:	''
			,	wantedListError:	''
			,	sourceName: 		originName.substring( 0, 25 )
			,	errorMsg:			''
			,	wantedList:			[]
			,	addedToWantedList:
					{
						added:			false
					,	targetName:		''
					,	addItemCnt:		50
					}
			,	disabledButton:		false
			};

		this.origin 		= origin;
		this.originName 	= originName;
		this.userCountry 	= blapp.session.codeCountryDetected;
		this.itemsToBuy		= itemsToBuy;				// Array of BLMInvFinderFindingItem
		this.findOption		= props.findOption;
		this.referID		= _.get( props, "referID", 0 );
		this.uploadFrom		= _.get( props, "uploadFrom", 100 );
		
		this._qtyToBuy			= 0;
		this._qtyUnavailable	= 0;
		this._keyResult			= null;
		this._result			= null;
		this._resultSingle		= null;
		this._wlFetch			= wlFetch;

		_.forEach( this.itemsToBuy, ( fi ) => this._qtyToBuy += fi.nQty );

		this.unavailableItems 	= [];
		this.stores 			= [];
		this.recommendedItems 	= [];
	}

	componentDidMount() 
	{
		if ( this._wlFetch >= 0 )
		{
			blapp.models.fetch( 
				"wanted_list"
			, 	{ 
					controller: "wanted.BLCWanted"
				,	method: 	"getWantedList"
				,	params: 	[ this._wlFetch ]
				,	refresh: 	true 
				} 
			)
			.then( 
				( data ) => 
				{
					this.originName	= data.strName;
					this.itemsToBuy	= EasyBuyModal.getItemsToBuyFromWantedListItem( data.idWantedList, data.items );
					this._qtyToBuy	= 0;

					_.forEach( this.itemsToBuy, ( fi ) => this._qtyToBuy += fi.nQty );

					this.setState( { sourceName:  data.strName.substring( 0, 25 ) } );
					this.checkUnavailability();
				} 
			).catch(
				( error ) =>
				{
					this.setState( { stage: 6, errorMsg: error } );
				}
			);
		}
		else
		{
			this.checkUnavailability();
		}
		console.log("---->EasyBuy open")
		blapp.track.trackGeneral(10008, this.getOriginForTracking(), 0, this.referID);

		onEscapePress(() => this.props.toggleModal());
	}

	getOriginForTracking()
	{
		switch(this.origin)
		{
			case 'wantedList':
				return 1;
			case 'gallery':
				return 2;
			default:
				return 0;
		}
	}

	componentDidUpdate() 
	{
		onEscapePress(() => this.props.toggleModal());
	}

	render() 
	{
		let headerClasses  = '';
			
		headerClasses += this.state.stage > 1 || this.state.inTransition ? ' item-finder-modal__header--hide-preloader' : '';
		headerClasses += this.state.stage == 5 ? ' item-finder-modal__header--show-success' : '';

		const successMessage 	= this.origin == 'wantedList' ? $T( "SUCCESS_MSG_WANTEDLIST", [ this.originName, this.stores.length ] ) : $T( "SUCCESS_MSG", [ this.stores.length ] );
		const customParts 		= this.props.customParts || 0;

		return (
			<div className="modal modal--medium">
				<div className="modal__overlay"></div>
				<div className="modal__content modal__content--sticky-footer" ref={modalContent => this.modalContent = modalContent}>
					<div className="modal__header">
						<div className="modal__title">
							{$T("EASY_BUY")}
						</div>
						<i className="far fa-times modal__close" onClick={() => this.props.toggleModal()}></i>
					</div>
					{
					this.state.stage == 6 ?
						this.renderError()
					:
					<div className={"modal__body l-pad-null" + (this.state.stage == 4 ? ' bg-color--cloud' : '')}>
						<div className={"item-finder-modal__header" + headerClasses}>
							{this.state.stage == 1 ?
								<div className="item-finder-modal__preloader l-margin-bottom">
									<Preloader classes="l-margin-bottom"/>
									<strong className="item-finder-modal__title item-finder-modal__title--large l-margin-bottom--sm">{$T("FINDING")}</strong>
									<p>{$T("THIS_MAY_TAKE")}</p>
								</div>
							: null}

							{this.state.stage >= 4 ?
								<strong className="item-finder-modal__title item-finder-modal__title--success">{successMessage}</strong>
							: null}

							{this.origin == 'wantedList' ? 
								<strong className={"item-finder-modal__origin" + (this.state.stage == 5 ? ' item-finder-modal__origin--animate' : ' l-margin-bottom')}>
									{$T("ITEMS_FROM",[this.originName])}
								</strong>
							: null}
							{this.state.stage != 5 ?
								<React.Fragment>
									<div className="l-inline-block text--left">
										<div className="text--center"><i className="far fa-cube l-margin-right"></i>{$T("UNIQUE_LOTS",[blapp.format.formatNumber( this.itemsToBuy.length )])}{customParts > 0 ? '*' : null}</div>
										<div className="l-margin-bottom text--center"><i className="far fa-cubes l-margin-right"></i>{$T("TOTAL_ITEMS",[blapp.format.formatNumber( this._qtyToBuy )])}</div>
									</div>
									{customParts > 0 ? <p><em>*Custom parts will be excluded in the results</em></p> : null}
								</React.Fragment>
							: null}

							{this.state.stage >= 5 ?
								<div className="item-finder-modal__success-btn">
									<a href={blapp.url2.getGlobalCartUrl()} className="btn btn--cta-alt l-block">{$T("VIEW_CART")}</a>
									{this.renderCreatedCartsList()}
								</div>
							: null}
						</div>

						{this.state.stage != 1 ? 
							this.renderUnavailableItems() 
						: null}
						
						<div className="item-finder-modal__content" ref={stageContent => this.stageContent = stageContent}>
							{this.renderItemFinderStage()}
						</div>
					</div>
					}
					{this.renderItemFinderFooter()}
				</div>
			</div>
		);
	}

	renderError()
	{
		return (
			<div className="modal__body l-pad-x--xl">
				{$T("ERROR_MSG")}<br/>
				({this.state.errorMsg})
			</div>
		);
	}

	renderItemFinderStage() 
	{
		switch (this.state.stage) 
		{
			case 1:
				return this.renderLoadingStage();

			case 2: 
				return this.renderInitialScan();

			case 3: 
				return this.renderFullscan();

			case 4:
				return this.renderResults();

			case 5:
				return this.renderSuccess();
		}
	}

	renderLoadingStage() 
	{
		return (
			<div className="text--center l-pad">
				{$T("LOADING_DESC")}
			</div>
		);
	}

	renderUnavailableItems() 
	{
		if ( this.state.addedToWantedList.added ) 
		{
			<div className="item-finder-modal__unavailable-parts">
				{$T("ITEMS_WERE_ADDED", [ this.state.addedToWantedList.addItemCnt ])} <strong>{this.state.addedToWantedList.targetName}</strong>"
				<button className="btn btn--link l-margin-top l-block">{$T("MANAGE_LIST")}</button>
			</div>
		}
		else if ( this._qtyUnavailable > 0 )
		{
			if ( this.origin != 'wantedList' && this._qtyUnavailable == this._qtyToBuy )
			{
				this.fetchMyWantedList();

				return (
					<div className="item-finder-modal__unavailable-parts">
						<strong className="l-pad l-block">{$T("BUMMER")}</strong>
						<div className="l-border--top l-pad-y l-pad-x--xl">
							<span>{$T("ADD_UNAVAILABLE_TO_WANTED")}</span>
							<DropdownInput 
								classes="l-margin-top l-full-width" 
								items={this.state.wantedList.map( ( wl ) => ({ id: String( wl.idWantedList ), name: wl.strName }) )} 
								inputPlaceholder={$T("NEW_WANTED_LIST_NAME")} 
								inputIDChange={(id) => this.updateWantedlist(id)} 
								inputValChange={(val) => this.updateNewWantedlist(val)} 
								inputID={this.state.selectedWantedList}
								inputValue={this.state.newWantedlist} 
							/>
						</div>
					</div>
				);
			}
			else
			{
				return (
					<div>
						<div className="item-finder-modal__unavailable-parts">
							<InfoDrawer classes="l-pad" bold label={$T( "ITEMS_ARE_UNAVAILABLE", [ this.unavailableItems.length ] )} icon="arrow">
								<HiddenScroll classes="l-pad-top--sm">
								{
									this.unavailableItems.map( 
										(fi, idx ) => <SimpleProductCard item={SimpleProductCard.getDataFromItem( fi.dmItemColor )} key={idx} qty={fi.nRemainingQty} qty2={fi.nQty} showUnavailable/>
									)
								}
								</HiddenScroll>
							</InfoDrawer>
						</div>
					</div>
				);
			}
		}
	}

	renderInitialScan() 
	{
		if ( this._qtyUnavailable == this._qtyToBuy )
		{
			return ( <div className="l-pad">{$T("BUMMER")}</div> );
		}
		else
		{
			return ( <div className="l-pad">{$T("THERE_ARE_ITEMS_UNAVAILABLE", [ this.unavailableItems.length, this.itemsToBuy.length - this.unavailableItems.length ])}</div> );
		}
	}

	renderFullscan() 
	{
		return (
			<div className="l-pad text--center">
				<Preloader classes="l-margin-bottom"/>
				<strong className="item-finder-modal__title l-margin-bottom--sm">{$T("FINDING")}</strong>
				<span>{$T("THIS_MAY_TAKE")}</span>
				<div className="text--center l-pad">
					{$T("LOADING_DESC")}
				</div>
			</div>
		);
	}

	renderResults() 
	{
		if ( this.stores.length == 0 )
		{
			return ( <div className="l-pad">{$T("BUMMER")}</div> );
		}
		else
		{
			return (
				<div>
					{this.renderStores()}
					{this.renderSourceName()}
				</div>
			);
		}
	}

	renderStores() 
	{
		let		mItemNetCost = 0;
		let		mItemEffCost = 0;

		if ( this._resultSingle )
		{
			_.forEach( 
				this._resultSingle.arrAltStores
			,	( st ) =>
				{
					let	nLotCnt		= 0;
					_.forEach(
						st.mapInv
					,	( inv ) => { ++nLotCnt}
					);

					mItemNetCost	+= st.mTotalItemNetPriceInDisplayCurrency;

					let	mEffCost	= st.mTotalItemNetPriceInStoreCurrency;

					if ( st.dmStore.mMinBuy > mEffCost )
						mEffCost	= st.dmStore.mMinBuy;
					if ( st.dmStore.mMinAvgLot > ( mEffCost / nLotCnt ) )
						mEffCost	= st.dmStore.mMinAvgLot * nLotCnt;

					mEffCost	= mEffCost * st.fExRateToDispCurrency;

					mItemEffCost	+= mEffCost;
				}
			);
		}
		else
		{
			mItemNetCost		= this._result.mTotalItemNetCost;
			mItemEffCost		= this._result.mTotalItemEffCost + this._result.mTotalEstimatedShippingCost;
		}

		let someForeign = this.stores.some(store => store.fExRateToDispCurrency != 1);
		return (
			<div className="l-pad--xl bg-color--white l-border--bottom">
				<strong className="text--small-title">{$T("GET_EVERYTHING",[this.unavailableItems.length == 0, this.stores.length])}</strong>
				{
					this.stores.map(
						(store, key) => 
						{
							return (
								<ModalStoreRow 
									store={ModalStoreRow.getStorePropFromBLMInvFinderStoreResult( store )} 
									showFlag={true} 
									key={key}/>
							);
						}
					)
				}
				<div className="l-flex l-split l-pad-top text--small-title">
					<strong className="text-color--primaryGreen">{$T("TOTAL")}</strong>
					<div className="text--right">
						<strong className="text-color--primaryGreen l-block">{someForeign ? '~' : ''}{blapp.format.formatMoney(mItemNetCost)}</strong>
					</div>
				</div>
				<div className="l-flex l-split text-color--darkestBlue">
					<strong className="">{$T("EST_TOTAL")} <i className="fas fa-info-circle js-bottom-center-tooltip" data-tooltip={$T("EST_TOTAL_TOOLTIP")} data-tooltip-width={150} onClick={(e) => ClickShowTooltip(e)}/></strong>
					<strong className="text--right">~{blapp.format.formatMoney(mItemEffCost)}</strong>
				</div>
			</div>
		);
	}

	renderCreatedCartsList() 
	{
		const stores = this.stores.map((store, key) => <SellerStoreLockup key={key} classes={this.stores.length - 1 > key ? "item-finder-modal__store-overview-item l-margin-bottom--sm" : "item-finder-modal__store-overview-item"} details={{flag: store.dmStore.codeCountry, storeName: store.dmStore.strStoreName, feedbackRank: blapp.util.getLevelFromFeedbackScore(store.dmStore.nFeedbackScore)}}/>)

		return (
			<div className={"item-finder-modal__store-overview" + (this.stores.length > 3 ? " item-finder-modal__store-overview--overflow" : "")}>
				{stores}
			</div>
		);
	}

	renderSourceName() 
	{
		return (
			<div className="l-pad--xl">
				<strong className="l-block l-margin-bottom text--small-title">
					{$T("SOURCE_NAME")} <i className="fas fa-info-circle js-bottom-center-tooltip l-cursor-pointer" data-tooltip={$T("SOURCE_NAME_TOOLTIP")} data-tooltip-width={150} onClick={(e) => ClickShowTooltip(e)}></i>
				</strong>
				<div className="l-margin-bottom--md">{$T("SOURCE_NAME_DESC")}</div>
				<LimitedTextField limit={25} inputClasses={this.state.sourceName.length == 0 ? 'border-color--primaryRed' : ''} func={(e) => this.setState({sourceName: e.target.value})} value={this.state.sourceName}/>
				{
					this.state.sourceName.length == 0 ? 
					<div className="l-margin-top">
						<span className="text-color--primaryRed">{$T("NAME_SOURCE")}</span>
						<button className="btn btn--link l-margin-left--xs" onClick={() => this.setState({sourceName: this.originName.substring( 0, 25 )})}>{$T("USE_DEFAULT")}</button>
					</div>
					: null
				}	
			</div>
		);
	}

	renderSuccess() 
	{
		if ( this.recommendedItems.length == 0 )
			return;

		return (
			<div>
				<div className="l-pad">
					<strong>{$T("RECOMMENDED_FOR_YOU")}</strong>
					<HiddenScroll classes="l-margin-top">
					{
						this.recommendedItems.map(
							(item, key) => 
							{
								let	itemData	= SimpleProductCard.getDataFromItem( item.dmItemColor );
								
								if ( blapp.config.disable_xp )
									itemData.link	= '//' + blapp.config.getHost( 'store' ) + '/' + item.dmStore.skUsernameOwner + '#/shop?o={"invID":"' + item.dmInv.idInv + '"}';
								else
									itemData.link	= blapp.url2.getCatalogItemPageUrl( item.dmItemColor.dmItem, item.dmInv.idColor, item.dmStore.idStore, item.dmInv.idInv );

								return (<SimpleProductCard item={itemData} key={key} />);
							}
						)
					}
					</HiddenScroll>
				</div>
				<GermanWarning classes="l-border--top l-pad l-margin-top"/>
			</div>
		);
	}

	renderItemFinderFooter() 
	{
		if ( this.state.stage == 1 || this.state.stage == 3 ) 
		{
			var		cinfo	= blapp.country.get( blapp.session.codeCountryDetected );
			var		cName	= cinfo != null ? cinfo.strCountryName : "Unknown";

			return (
				<div className="modal__footer text--center item-finder-modal__footer">
					<i className="fas fa-map-marker item-finder-modal__location-icon"></i> {cName}
				</div>
			);
		}
		else if ( this.state.stage == 2 || ( this.state.stage == 4 && this.stores.length == 0 ) ) 
		{
			if ( this._qtyToBuy == this._qtyUnavailable ) 
			{
				if ( this.origin == 'wantedList' )
				{
					return (
						<div className="modal__footer text--center item-finder-modal__footer" ref={footer => this.footer = footer}>
							<button className="btn btn--cta l-full-width" onClick={() => this.props.toggleModal()}>
								{$T("TRY_AGAIN_LATER")}
							</button>
						</div>
					);					
				}
				else
				{
					return (
						<div className="modal__footer text--center item-finder-modal__footer" ref={footer => this.footer = footer}>
							<button className="btn btn--cta l-full-width" onClick={(e)=>this.addToWanted()}>
								{$T("ADD_TO_WANTED_LIST")}
							</button>
							{ this.state.wantedListError ? <div className="l-pad text--center">{this.state.wantedListError}</div> : null }
						</div>
					);
				}
			}
			else
			{
				return (
					<div className="modal__footer text--center item-finder-modal__footer" ref={footer => this.footer = footer}>
						<button className="btn btn--cta l-full-width" disabled={this.state.inTransition} onClick={() => this.transitionStage(3)}>
							{$T("FINDING_REMAINING_ITEMS")}
						</button>
					</div>
				);
			}
		}
		else if ( this.state.stage == 4 && this.stores.length > 0 ) 
		{
			return (
				<div className="modal__footer text--center item-finder-modal__footer" ref={footer => this.footer = footer}>
					<button disabled={this.state.sourceName.length == 0 || this.state.disabledButton} className="btn btn--cta-alt l-full-width" onClick={() => this.createCarts()}>
						{$T("CREATE_CARTS")}
					</button>
				</div>
			);
		}
		else if ( this.state.stage == 6 )
		{
			return (
				<div className="modal__footer text--center item-finder-modal__footer" ref={footer => this.footer = footer}>
					<button className="btn btn--cta l-full-width" onClick={() => this.props.toggleModal()}>
						{$T("TRY_AGAIN_LATER")}
					</button>
				</div>
			);					
		}
	}

	transitionStage(stage) 
	{
		const transitionDuration = 200;

		this.setState({inTransition: true});
		this.stageContent.classList.add('item-finder-modal__content--transition');

		setTimeout(
			() => 
			{
				this.setState({stage: stage, inTransition: false});
				this.stageContent.classList.remove('item-finder-modal__content--transition');
			}
		,	transitionDuration * 2
		);

		if ( stage == 3 )
		{
			this.findSuggestion();
		}

		if ( stage == 5 ) 
		{
			this.footer.classList.add('item-finder-modal__footer--transition');

			setTimeout(
				() => this.modalContent.classList.remove('modal__content--sticky-footer')
			, 	transitionDuration * 4
			);
		}
	}

	checkUnavailability()
	{
		blapp.models.fetch(
			"unavailables"
		,	{
				controller:	"finder.BLCInvFinder"
			,	method:		"findUnavailableItemsQuick"
			,	params:		[ this.itemsToBuy, this.findOption ]
			,	refresh:	true
			,	sub:		true
			}
		).then(
			( data ) =>
			{
				if ( data.length > 0 )
				{
					this.unavailableItems	= data;
					this._qtyUnavailable	= 0;
					_.forEach( data, ( fi ) => this._qtyUnavailable += fi.nRemainingQty );
					this.transitionStage( 2 );
				}
				else
				{
					this.transitionStage( 3 );
				}
			}
		).catch (
			( err ) =>
			{
				this.setState( { stage: 6, errorMsg: err } );
			}
		);		
	}

	findSuggestion()
	{
		if ( this.itemsToBuy.length == 1 && _.isEqual( this.props.findOption, { op_only: true } ) )
		{
			let	fi	= this.itemsToBuy[ 0 ];

			blapp.models.fetch(
				"result_singleitem"
			,	{
					controller:		"finder.BLCInvFinder"
				,	method:			"findSingleItemResult"
				,	params:			[
										fi.idItem
									,	fi.idColor
									,	fi.condNew == 'U' ? false : true
									,	fi.bSealed ? true : false
									,	fi.nQty
									,	0
									,	"MULTIPLE_STORE"
									,	"default"
									]
				,	sub:			true
				,	refresh:		true
				}
			).then(
				( data ) =>
				{
					this.processSingleItemResult( data );
				}
			).catch(
				( err ) =>
				{
					this.setState( { stage: 6, errorMsg: err } );
				}
			);
		}
		else
		{
			blapp.models.fetch(
				"result"
			,	{
					controller:		"finder.BLCInvFinder"
				,	method:			"findSuggestion"
				,	params:			[ this.itemsToBuy, this.findOption ]
				,	sub:			true
				,	refresh:		true
				}
			).then(
				( data ) =>
				{
					this.processResultStatus( data );
				}
			).catch(
				( err ) =>
				{
					this.setState( { stage: 6, errorMsg: err } );
				}
			);
		}
	}

	processSingleItemResult( data )
	{
		this._resultSingle		= data;
		this._result			= null;

		let ufi	= _.clone( this.itemsToBuy[ 0 ] );

		ufi.dmItemColor	= data.dmItemImage;

		if ( _.isEmpty( data.arrAltStores ) )
		{
			ufi._qtyUnavailable		= this._qtyToBuy;
			ufi.nRemainingQty		= ufi._qtyUnavailable;

			this.unavailableItems.push( ufi );

			this._qtyUnavailable	= this._qtyToBuy;
			this.stores				= [];
		}
		else
		{
			let		nQtyBuy	= 0;
			
			_.forEach(
				data.arrAltStores
			,	( s ) =>
				{
					if ( s.mapInvs )
					{
						_.forEach( s.mapInvs, ( inv ) => { nQtyBuy += inv.nBuyQty; } )
					}
				}
			);

			this._qtyUnavailable	= this._qtyToBuy - nQtyBuy;

			if ( this._qtyUnavailable > 0 )
			{
				ufi._qtyUnavailable		= this._qtyUnavailable;
				ufi.nRemainingQty		= ufi._qtyUnavailable;

				this.unavailableItems.push( ufi );
			}

			this.stores				= data.arrAltStores;
		}
		console.log("--->EasyBuy Results 2")
		blapp.track.trackGeneral(10011, this.getOriginForTracking(), 0, this.referID);

		this.transitionStage( 4 );
	}

	processResultStatus( status )
	{
		if ( status.status == 'DONE' )
		{
			if ( status.result == null ) {
				this.setState( { stage: 6, errorMsg: "Failed : " + status.errorMsg } );
			} else {
				this._resultSingle		= null;
				this._result			= status.result;
				this.stores				= status.result.arrStoreResults;			
				this.unavailableItems	= [];
				this._qtyUnavailable	= 0;

				_.forEach( 
					status.result.mapFindingItems
				,	( fi ) => 
					{ 
						if ( fi.nRemainingQty > 0 )
						{
							this.unavailableItems.push( fi );
							this._qtyUnavailable	+= fi.nRemainingQty;
						}
					}
				);

				if ( this.stores == null )
				{
					this._qtyUnavailable	= this._qtyToBuy;
					this.stores				= [];
				}
				console.log("--->EasyBuy Results 1")
				blapp.track.trackGeneral(10011, this.getOriginForTracking(), this.stores.length, this.referID);

				this.transitionStage( 4 );
			}
		}
		else if ( status.status == 'FAILED' )
		{
			this.setState( { stage: 6, errorMsg: "Failed : " + status.errorMsg } );
		}
		else
		{
			this._keyResult	= status.key;

			setTimeout(
				() =>
				{
					blapp.models.fetch(
						"result"
					,	{
							controller:		"finder.BLCInvFinder"
						,	method:			"getFindingStatus"
						,	params:			[ this._keyResult ]
						,	sub:			true
						,	refresh:		true
						}
					).then(
						( data ) =>
						{
							this.processResultStatus( data );
						}
					).catch(
						( err ) =>
						{
							this.setState( { stage: 6, errorMsg: err } );
						}
					);
				}
			,	2000
			);
		}
	}

	updateWantedlist(id)
	{
		this.setState({selectedWantedList: id});
	}

	updateNewWantedlist(value) 
	{
		this.setState({newWantedlist: value});
	}

	fetchMyWantedList()
	{
		if ( blapp.session.isLoggedIn() && this.state.wantedList.length == 0 )
		{
			blapp.models.fetch( 
				"wanted_list"
			,	{
					controller:	"wanted.BLCWanted"
				,	method:		"getList"
				,	refresh:	true
				}
			).then(
				( data ) =>
				{
					this.setState( { wantedList: data } );
				}
			);
		}
	}

	createCarts()
	{
		let	stores		= [];
		let	invs		= [];
		let invsToCart	= [];
		let	st			= _.get( { "wantedList": 1, "gallery": 2, "mosaic": 3 }, this.origin, 99 )
		let	uploadFrom	= st == 1 ? 1 : ( this.uploadFrom || -1 );
		let	sd			= '' + this.generateUUID() + '=' + st + ":" + uploadFrom;
		let	smi			= this.props.srcMap ? _.clone( this.props.srcMap ) : {};
		let	mapIB		= {};

		smi.METHOD	= blapp.srcmap.METHOD.EASYBUY;

		if ( st == 1 || st == 2 || st == 3 )
			sd	+= "-" + ( this.referID || smi.idSrcFrom || 0 );

		_.forEach( this.itemsToBuy, ( ib ) => { mapIB[ ib.keyFind ] = ib;} );

		_.forEach(
			this._resultSingle ? this._resultSingle.arrAltStores : this._result.arrStoreResults
		,	(s) => 
			{
				stores.push( s.dmStore.idStore );
				_.forEach( 
					s.mapInvs
				,	( v, k ) => 
					{
						let	strSrcString	= null;

						if ( st == 1 )
							_.forEach( v.mapBuy, ( vv, kk ) => { strSrcString = blapp.srcmap.buildSrcString( blapp.srcmap.SRCTYPE.WANTED_ITEM, kk, vv, strSrcString ); } );
			
						invs.push( parseInt( k ) );
						invsToCart.push( { idInv: v.dmInv.idInv, idStore: s.dmStore.idStore, nQty: v.nBuyQty, sourceType: 7 /* EasyBuy */, sourceData: sd, strSrcString: strSrcString != "" ? strSrcString : null } );
					} 
				);
			}
		);

		this.setState( { disabledButton: true } );

		blapp.models.fetchMultiple(
			[
				{
					name:			"cart_results"
				,	controller:		"cart.BLCCart"
				,	method:			"addItemsToMyCart"
				,	params:			[ invsToCart, null, this.state.sourceName, true, smi ]
				,	refresh:		true
				}
			,	{
					name:			"recommendations"
				,	controller:		"finder.BLCRecommendationFinder"
				,	method:			"getRecommendedInvsByStores"
				,	params:			[ stores, invs ]
				,	refresh:		true
				}
			]
		).then(
			() =>
			{
				this.setState( { disabledButton: false } );
				
				let	errCart	= blapp.models.getError( "cart_results" );
				let errRec	= blapp.models.getError( "recommendations" );

				if ( errCart == null )
				{
					let	cart_results	= blapp.models.get( "cart_results" );

					_.forEach(
						cart_results
					,	( r ) =>
						{
							if ( r.error != "EC_OK" )
								errCart	= "Cart failure!";
						}
					);
					console.log("--->EasyBuy Create carts")
					blapp.track.trackGeneral(10009, this.getOriginForTracking(), stores.length, this.referID);
				}

				if ( errCart != null )
				{
					this.setState( { stage: 6, errorMsg: errCart } );
					return;
				}

				this.recommendedItems	= ( errRec == null ) ? blapp.models.get( "recommendations" ) : [];

				
				blapp.session.refresh( false );
				window.rebuildCartNav();
				this.transitionStage(5);
			}
		).catch( 
			( err ) =>
			{
				this.setState( { disabledButton: false } );
				this.transitionStage(5);
			}
		);
	}

	triggerAlert(message) {
		const confirmContent = `<i class="text-color--primaryRed fas fa-exclamation-triangle l-margin-bottom"></i>
		<p class="text-color--primaryRed">${message}</p>`;

		CustomAlert(confirmContent);
	}

	addToWanted()
	{
		let	idWantedList	= this.state.selectedWantedList == "" ? -1 : parseInt( this.state.selectedWantedList );
		let	wlItems			= [];
		let	smi				= this.props.srcMap ? _.clone( this.props.srcMap ) : {};
		let uploadFrom		= 100;

		if ( this.origin == "gallery" )
		{
			if ( this.uploadFrom == 0 )			// From Studio
				uploadFrom	= 3;
			else if ( this.uploadFrom == 1 )	// From Web
				uploadFrom	= 4;
			else if ( this.uploadFrom == 2 )	// From Mosaic
				uploadFrom	= 21;
		}

		smi.METHOD	= blapp.srcmap.METHOD.EASYBUY;

		_.forEach(
			this.itemsToBuy
		,	( ib ) =>
			{
				wlItems.push(
					{
						idItem:			ib.idItem
					,	nWantedColorId:	ib.idColor
					,	nWantedQty:		ib.nQty
					,	strCondition:	ib.condNew
					,	strRemarks:		"Added from Easy Buy"
					,	strSrcString:	ib.strSrcString ? ib.strSrcString : null
					}
				);
			}
		);

		blapp.models.fetch(
			"_add_to_list_result"
		,	{
				controller:	"wanted.BLCWanted"
			,	method:		"addItems"
			,	params:		[ isNaN( idWantedList ) ? 0 : idWantedList, this.state.newWantedlist, JSON.stringify( wlItems ), uploadFrom , true, smi ]
			,	refresh:	true

			}
		).then(
			(data) =>
			{
				switch ( data )
				{
				case "EC_OK":
					console.log("---> EasyBuy Add to WL")
					blapp.track.trackGeneral(10010, this.getOriginForTracking(), 0, this.referID);		
					this.props.toggleModal();
					break;
				case "EC_WL_NAME_EXISTS":	
					this.triggerAlert( $T( "ERRWL_WL_NAME_EXISTS" ) );
					break;
				case "EC_DUPLICATED_DATA":
					this.triggerAlert( $T( "ERRWL_DUPLICATED_DATA" ) );
					break;
				default:
					this.triggerAlert( $T( "ERRWL_EC_UNHANDLED_EXCEPTION", [ data ] ) );
					break;
				}
			}
		).catch(
			(err) =>
			{
				this.triggerAlert( $T( "ERRWL_EC_UNHANDLED_EXCEPTION", [ err ] ) );
			}
		);
	}

	generateUUID() 
	{
		var d 		= new Date().getTime();
		var uuid 	= 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
							/[xy]/g
						,	(c) =>
							{
								var r = ( d + Math.random() * 16 ) % 16 | 0;
								d 	= Math.floor( d / 16 );
								return (c=='x' ? r : (r&0x3|0x8)).toString(16);
							}
						);
	    return uuid;
	}

	static getItemsToBuyFromWantedListItem( idWantedList, list )
	{
		var	arrFindingItems	=	[];

		_.forEach( 
			list
		,	( item, idx ) =>
			{
				var	nQty	= Math.max( item.nWantedQty, 1 ) - item.nHaveQty;
				
				if ( nQty > 0 )
				{
					var		fi	=	{
										keyFind:		item.idWantedItem
									,	idItem:			item.dmItemImage.dmItem.idItem	
									,	idColor:		item.nWantedColorId
									,	nQty:			nQty
									,	bMandatory:		false
									,	condNew:		item.strCondition
									,	mMaxPrice:		item.mMaxPrice > 0 ? item.mMaxPrice : null
									,	idMore:			idWantedList
									,	strSrcString:	blapp.srcmap.buildSrcString( blapp.srcmap.SRCTYPE.WANTED_ITEM, item.idWantedItem, nQty )
									};

					arrFindingItems.push( fi );
				}
			}
		);

		return arrFindingItems;
	}
}

var $T	= BLComponent.createTextMap( 
	{
		"EASY_BUY":
			{
				en:	"Easy Buy"
			,	kr:	"간편 구매"
			,	es: "Easy Buy"
			}
	,	"ERROR_MSG":
			{
				en: "Error occurred while processing your request! Please try again later!"
			,	kr: "요청 처리 중 에러가 발생하였습니다. 잠시 후 다시 시도해 주세요!"
			,	es: "Ocurrió un error procesando tu petición. Inténtalo más tarde."
			}
	,	"SUCCESS_MSG_WANTEDLIST":
			{
				en: "Nice! The items from {{$0}} were successfully added to {{$1?s=( cart):( carts)}}."
			,	kr: "성공적으로 카트에 추가되었습니다!"
			,	es: "Los productos de {{$0}} han sido añadidos a {{$1?s=( cesta):( cestas)}}."
			}
	,	"SUCCESS_MSG":
			{
				en: "Nice! The items below were successfully added to {{$0?s=( cart):( carts)}}."
			,	kr: "성공적으로 카트에 추가되었습니다!"
			,	es: "Los siguientes productos han sido añadidos a {{$0?s=( cesta):( cestas)}}."
			}
	,	"UNIQUE_LOTS":
			{
				en:	"{{$0?s=( lot):( lots)}}"
			,	kr:	"{{$0}} 품목"
			,	es: "{{$0?s=( lote):( lotes)}}"
			}
	,	"TOTAL_ITEMS":
			{
				en:	"{{$0?s=( item):( items)}}"
			,	kr:	"{{$0}}개 아이템"
			,	es: "{{$0?s=( producto):( productos)}}"
			}
	,	"ITEMS_FROM":
			{	
				en:	"Items from {{$0}}"
			,	kr:	"{{$0}}에서 선택된 아이템"
			,	es: "Elementos de {{$0}}"
			}
	,	"VIEW_CART":
			{
				en:	"View carts and checkout"
			,	kr:	"카트 보기"
			,	es: "Ver cestas y realizar pedido"
			}
	,	"LOADING_DESC":
			{
				en:	"We're finding the most practical and optimal combination of BrickLink stores by comparing item prices and estimated shipping fees to minimize the total price of orders."
			,	kr: "아이템 가격 및 예상 배송비를 고려하여 가장 최적화된 구매 조합을 찾고 있습니다."
			,	es: "Estamos buscando la combinación más óptima de tiendas en BrickLink comparando precios y gastos de enío estimados para minimizar el precio total de las órdenes."
			}
	,	"ITEMS_WERE_ADDED":
			{
				en:	"{{$0?s=( item was):( items were)}} added to the Wanted List "
			,	kr:	"{{$0}} 아이템이 다음 위시리스트에 추가되었습니다. : "
			,	es: "{{$0?s=( producto fue añadido):( productos fueron añadidos)}} a la Lista de deseo "
			}
	,	"MANAGE_LIST":
			{
				en:	"Manage list"
			,	kr: "리스트 관리"
			,	es: "Gestionar lista"
			}
	,	"BUMMER":
			{
				en:	"Bummer. It looks like there are no stores with the items in stock."
			,	kr:	"아이템을 보유한 스토어를 찾을 수 없습니다."
			,	es: "Parece que no hay ninguna tienda con estos productos disponibles."
			}
	,	"ADD_UNAVAILABLE_TO_WANTED":
			{
				en:	"Add unavailable items to a new or existing Wanted List."
			,	kr:	"해당 아이템을 내 위시리스트에 추가"
			,	es: "Añadir los productos no disponible a una Lista de deseo."
			}
	,	"NEW_WANTED_LIST_NAME":
			{
				en:	"New Wanted List Name"
			,	kr:	"새 위시리스트 이름"
			,	es: "Nombre de la Lista de deseo"
			}
	,	"ITEMS_ARE_UNAVAILABLE":
			{
				en:	"{{$0?s=( item is):( items are)}} unavailable"
			,	kr:	"{{$0}}개 아이템 구매 불가"
			,	es: "{{$0?s=( producto no está disponible):( productos no están disponibles)}}"
			}
	,	"THERE_ARE_ITEMS_UNAVAILABLE":
			{
				en:	"There are {{$0?s=( item that is):( items that are)}} unavailable. Would you like to find the other {{$1?s=( item):( items)}}?"
			,	kr:	"{{$0}}개 아이템에 대해 구매 가능한 스토어를 찾지 못했습니다. 다른 {{$1}}개 아이템에 대해 찾기를 계속 하시겠습니까?"		
			,	es: "Hay {{$0?s=( producto no disponible):( productos no disponibles)}}.¿Quieres buscar {{$1?s=( producto restante):( productos restantes)}}?"
			}
	,	"FINDING":
			{
				en:	"Finding..."
			,	kr:	"찾는중..."
			,	es: "Buscando..."
			}
	,	"THIS_MAY_TAKE":
			{
				en:	"This may take a few minutes."
			,	kr:	"작업에 다소 시간이 걸릴 수 있습니다."
			,	es: "Esto puede tomar unos minutos."
			}
	,	"GET_EVERYTHING":
			{
				en:	"Get everything {{$0?():(else)}} from {{$1?s=( store):( stores)}}"
			,	kr: "다음 {{$1}}개 스토어에서 {{$0?(모든):(남은)}} 아이템을 구입할 수 있습니다."
			,	es: "Consigue todo {{$0?():(lo demás)}} de {{$1?s=( tienda):( tiendas)}}"
			}
	,	"TOTAL":
			{
				en:	"Order total"
			,	kr: "주문 총계"
			,	es: "Total"
			}
	, "EST_TOTAL":
			{
				en: "Est. grand total"
			,	kr: ""
			,	es: ""
			}
	, "EST_TOTAL_TOOLTIP":
			{
				en: "We take shipping cost, fees, exchange rates, etc. to find you the best options available."
			,	kr: ""
			,	es: ""
			}
	,	"SOURCE_NAME":
			{
				en:	"Source name"
			,	kr:	"출처"
			,	es: "Nombre del origen"
			}
	,	"SOURCE_NAME_TOOLTIP":
			{
				en:	"An item's source is the method by which it was added to your cart"
			,	kr:	"카트의 출처 정보 파악 시 본 정보가 이용됩니다."
			,	es: "El origen de un producto es el método que se usó para añadirlo a la cesta"
			}
	,	"SOURCE_NAME_DESC":
			{
				en: "Items added through Easy Buy will be tagged as an Easy Buy source. Name this source for future reference."
			,	kr:	"간편 구매를 통해 추가된 아이템은 간편 구매를 출처로 취급됩니다. 향후 참조를 위해 출처 이름을 정해 주세요."
			,	es: "Los productos añadidos mediante Easy Buy tendrán como origen Easy Buy. Nombra este origen para referencias futuras."
			}
	,	"RECOMMENDED_FOR_YOU":
			{
				en:	"Recommended for you"
			,	kr:	"추천 아이템"
			,	es: "Recomendados para ti"
			}
	,	"ADD_TO_WANTED_LIST":
			{
				en:	"Add to Wanted List"
			,	kr: "위시리스트에 추가"
			,	es: "Añadir a una Lista de deseo"
			}
	,	"FINDING_REMAINING_ITEMS":
			{
				en:	"Find remaining items"
			,	kr:	"남은 아이템으로 찾기"
			,	es: "Buscar los productos restantes"
			}
	,	"CREATE_CARTS":
			{
				en:	"Create carts"
			,	kr:	"카트에 추가"
			,	es: "Crear cestas"
			}
	,	"TRY_AGAIN_LATER":
			{
				en:	"Try again later"
			,	kr:	"다음에 다시 하기"
			,	es: "Intentar de nuevo más tarde"
			}
	,	"NAME_SOURCE":
			{
				en:	"Please name source or"
			,	kr:	""
			,	es: ""
			}
	,	"USE_DEFAULT":
			{
				en:	"use default"
			,	kr:	"기본값 사용"
			,	es: "usar por defecto"
			}
	,	"ERRWL_WL_NAME_EXISTS":
			{
				en:	"Wanted list of same name already exists!"
			,	kr:	"동일 이름의 위시리스트가 이미 존재합니다!"
			,	es: "¡Ya existe una lista con ese nombre!"
			}
	,	"ERRWL_DUPLICATED_DATA":
			{
				en:	"Duplicated entry!"
			,	kr: "중복된 아이템이 존재합니다!"
			,	es:	"¡Información duplicada!"
			}
	,	"ERRWL_EC_UNHANDLED_EXCEPTION":
			{
				en:	"Add to wanted list error! ({{$0}})"
			,	kr: "위시리스트 추가에 실패하였습니다! ({{$0}})"
			,	es:	"¡Error añadiendo a la lista!"
			}
	}
);